/** Shown in place of a missing value in the source-data panel. */
export const DASH = "—";
